import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { ExutoireDto, TypeDechetDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-exutoire-select',
  templateUrl: './exutoire-select.component.html',
  styleUrls: ['./exutoire-select.component.css']
})
export class ExutoireSelectComponent implements OnInit, OnDestroy {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
  @Select(ControlPanelStore.exutoires$) exutoires$: Observable<ExutoireDto[]>;

  @Input('width') width: number;

  @Input() exutoireId: number;
  @Output() exutoireIdChange = new EventEmitter<number>();

  @Input() cell: any;

  @Input() disabled: boolean = false;

  InitId = null;

  Exutoires: ExutoireDto[] = [];
  SelectedExutoire: ExutoireDto = null;
  ColumnName = [];

  e: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'Identifiant'
      ]
    ).subscribe(translations => {
      this.ColumnName.push(translations['Identifiant']);
    });
  }

  ngOnInit() {
    if (this.exutoireId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.exutoireId));
    }

    this.e = this.exutoires$.subscribe(res => {
      if (res != null) {
        this.Exutoires = res.sort((a,b) => (a.Identifiant > b.Identifiant) ? 1 : ((b.Identifiant > a.Identifiant) ? -1 : 0));
      }
    });
  }

  ngOnDestroy() {
    this.e?.unsubscribe();
  }

  updateInfo(event) {
    this.exutoireId = event.currentSelectedRowKeys.length === 1 ? event.currentSelectedRowKeys[0].Id : this.exutoireId;
    if (!!this.cell && this.InitId !== this.exutoireId) {
      this.cell.setValue(this.exutoireId);
    }
    this.exutoireIdChange.emit(this.exutoireId);

    if(this.exutoireId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.exutoireId == null) {
      this.dataGrid.instance.clearSelection();
    }
  }
}
